// Custom code: cart gift (drawer slider)
if (typeof CartGiftDrawer !== "function") {
  class CartGiftDrawer extends HTMLElement {
    connectedCallback() {
      this.initContent();

      // The host is never destroyed (only its inner content is swapped on
      // refresh), so the cart-updated wiring lives here and binds once.
      if (!this.wired) {
        this.wired = true;
        const cartForm = document.querySelector("cart-form");
        if (cartForm) {
          cartForm.addEventListener("cart-updated", () => this.refresh());
        }
      }
    }

    initContent() {
      this.bindOverlay();
      this.bindAdd();
    }

    bindOverlay() {
      const module = this.querySelector(".cart-gift-drawer");
      const overlay = this.querySelector("[data-overlay]");
      const openButton = this.querySelector("[data-open-overlay]");
      const closeButton = this.querySelector("[data-close-overlay]");
      if (!module || !overlay) {
        return;
      }
      if (openButton) {
        openButton.addEventListener("click", () => {
          overlay.hidden = false;
          module.classList.add("cart-gift-drawer--overlay-open");
        });
      }
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          overlay.hidden = true;
          module.classList.remove("cart-gift-drawer--overlay-open");
        });
      }
    }

    bindAdd() {
      this.querySelectorAll("[data-add]").forEach((button) => {
        button.addEventListener("click", () => this.addGift(button));
      });
    }

    async addGift(button) {
      const variantId = button.getAttribute("data-variant-id");
      if (!variantId || button.classList.contains("processing")) {
        return;
      }

      button.classList.add("processing");

      try {
        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });
      } catch (error) {
        console.log(error);
        button.classList.remove("processing");
        return;
      }

      // Refresh the cart line items / subtotal and re-open the drawer.
      if (window.refreshCart) {
        window.refreshCart();
      }

      // Let the progress bar, auto-gift and this module react to the new total.
      const cartForm = document.querySelector("cart-form");
      if (cartForm) {
        cartForm.dispatchEvent(new Event("cart-updated"));
      }
    }

    async refresh() {
      const res = await fetch(
        window.Shopify.routes.root + "?section_id=cart-gift-drawer",
      );
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, "text/html");
      const fresh = doc.querySelector("cart-gift-drawer");
      if (!fresh) {
        return;
      }
      this.innerHTML = fresh.innerHTML;
      this.initContent();
    }
  }

  if (typeof customElements.get("cart-gift-drawer") == "undefined") {
    customElements.define("cart-gift-drawer", CartGiftDrawer);
  }
}
